import { INewUser } from "@wingspanhq/users";

export const selectorIsEngagementsActive = (user: INewUser) => {
  return !!user.labels.engagements;
};
